export default __webpack_public_path__ + "static/media/StatusEndedWithErrors.abc7f0bd.png";